export default __webpack_public_path__ + "static/media/hospital.f7f2cfc6.svg";